import { clsx } from 'clsx';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import type { FieldError } from 'react-hook-form';

interface Props {
  label?: ReactNode;
  isSmall?: boolean;
  fixedWidth?: boolean;
  required?: boolean;
  id?: string;
  radioCheckboxClassname?: string;
  labelClassName?: string;
}

const RadioCheckboxLabelText = ({
  label,
  isSmall,
  required,
  fixedWidth,
  id,
  radioCheckboxClassname,
  labelClassName,
}: Props) => {
  const t = useTranslations('common.form.obligatory');

  return (
    label && (
      <div
        className={clsx(
          'flex flex-col',
          isSmall && 'pt-3',
          radioCheckboxClassname,
        )}
      >
        {label && (
          <>
            <label
              htmlFor={id}
              className={clsx(
                'flex gap-xs',
                isSmall && 'text-small',
                labelClassName,
              )}
            >
              <span>{label}</span>
              {!fixedWidth && required && (
                <span className="text-muted">{t('required')}</span>
              )}
            </label>
            {fixedWidth && required && (
              <span
                className={clsx('text-default italic', isSmall && 'text-small')}
              >
                {t('required')}
              </span>
            )}
          </>
        )}
      </div>
    )
  );
};

type Switch = boolean | undefined;

const useBgState = (error: Switch, disabled: Switch, checked: Switch) => {
  if (error) return 'default';
  if (disabled && checked) return 'disabled';
  if (checked) return 'checked';

  return 'default';
};

const useBorderState = (error: Switch) => {
  if (error) return 'error';

  return 'default';
};

export const useBgBorder = (
  error: FieldError | undefined,
  disabled: Switch,
  checked: Switch,
) => [useBgState(!!error, disabled, checked), useBorderState(!!error)] as const;

export default RadioCheckboxLabelText;
